export enum DefaultSelectionType {
  None = 'none',
  BiteOrPos = 'bite-or-pos',
  Bite = 'bite',
  Pos = 'pos',
}
